import { render, staticRenderFns } from "./ReleaseConceptTerritory.vue?vue&type=template&id=76f12a16&"
import script from "./ReleaseConceptTerritory.vue?vue&type=script&lang=js&"
export * from "./ReleaseConceptTerritory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports